import { Palette } from '@core/config/constants';

/** Configuracion del minijuego de memoria (encontrar parejas de personajes). */
export const MemoryConfig = {
  key: 'MemoryScene',
  title: 'Memoria',
  description: 'Encontrá las parejas de las chicas de LUMINOVA.',
  icon: '🧠',
  color: Palette.highlight,

  /** Puntos base por cada pareja encontrada. */
  pointsPerMatch: 100,
  /** Bonus de puntos por cada movimiento "ahorrado" respecto al ideal. */
  bonusPerSavedMove: 10,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;

/** Parametros de cada nivel de dificultad del minijuego de memoria. */
export interface MemoryDifficulty {
  readonly key: string;
  readonly label: string;
  readonly color: number;
  /** Cantidad de parejas (cartas = parejas x 2). */
  readonly pairs: number;
}

export const MEMORY_DIFFICULTIES: readonly MemoryDifficulty[] = [
  { key: 'easy', label: '😊 Fácil', color: Palette.accent, pairs: 3 },
  { key: 'normal', label: '⭐ Normal', color: Palette.secondary, pairs: 4 },
  { key: 'hard', label: '🔥 Difícil', color: Palette.primary, pairs: 6 },
];
